import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { withCandyApiDraftClient } from "../../../withCandyApiDraftClient";

import { PrintErrorLog } from "./PrintErrorLog";

const mapStateToProps = (state: FullFormState) => {
    const { errorLogName, propsName } = state.errorLog.form;

    return {
        propsName: propsName ?? "",
        errorLogName: errorLogName ?? "",
    };
};

export const PrintErrorLogContainer = withCandyApiDraftClient(connect(mapStateToProps)(PrintErrorLog));
